'use client';

import { useQuery } from '@tanstack/react-query';
import { useEffect, useRef } from 'react';
import { QueryApi } from '@/features/query/api';
import { getPendingSyncReadIds, setNewsReadSyncQueueEnabled } from './news-read-storage';
import { syncGuestNewsReadAfterLogin } from './sync-guest-news-read';

/** Covers login without going through Login mutation (existing session) and pending guest reads. */
export const useSyncGuestNewsReadOnAuth = () => {
    const customerQuery = useQuery(QueryApi.Customer.queries.Customer);
    const syncingRef = useRef(false);

    useEffect(() => {
        if (!customerQuery.isFetched) return;

        if (!customerQuery.data) {
            syncingRef.current = false;
            setNewsReadSyncQueueEnabled(true);
            return;
        }

        if (syncingRef.current) return;
        if (getPendingSyncReadIds().size === 0) {
            setNewsReadSyncQueueEnabled(false);
            return;
        }

        syncingRef.current = true;
        void syncGuestNewsReadAfterLogin().finally(() => {
            syncingRef.current = false;
        });
    }, [customerQuery.isFetched, customerQuery.data]);
};
